import get from 'lodash/get';
import React, {
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import URL from 'url-parse';

import Loading from 'components/Loading';
import Page from 'containers/Page';
import { useMutation, useQuery } from '@apollo/client';
import { useRouter } from 'found';
import styles from './index.scss';
import { GET_TRACKER_LINK_BY_SLUG } from '../../schema/apolloQueries/trackerLinkQueries';
import { COUNT_LINK_CLICK } from '../../schema/apolloMutations/trackableLinkMutations';
import { GET_PROFILE_INFO } from '../../schema/apolloQueries/commonQueries';

const OldLinkPage = () => {
  const {
    match: { location: wLocation, params: { linkSlug } },
  } = useRouter();
  const [countLinkClick] = useMutation(COUNT_LINK_CLICK);
  const { data: profileData, loading: ploading } = useQuery(GET_PROFILE_INFO);
  const { data, loading } = useQuery(GET_TRACKER_LINK_BY_SLUG, {
    variables: { slug: encodeURIComponent(linkSlug) },
  });
  const redirect = useCallback(
    () => {
      if (window) {
        let destinationUrl = data?.getTrackerLinkBySlug?.destination;
        const personId = profileData?.getProfile?.personId
          ? profileData?.getProfile?.personId
          : null;
        if (personId) {
          destinationUrl = destinationUrl.replaceAll(
            '{{Attributes.Table_person_id}}',
            personId,
          );
        }
        window.location.replace(destinationUrl);
      }
    },
    [
      data?.getTrackerLinkBySlug?.destination,
      profileData?.getProfile,
    ],
  );

  const location = useMemo(() => {
    try {
      return window?.location;
    } catch (e) {
      return wLocation;
    }
  }, [wLocation]);

  useEffect(
    () => {
      if (!loading && data?.getTrackerLinkBySlug && !ploading && profileData) {
        const skipClick = get(location, 'state.skipClick');
        if (skipClick) {
          redirect();
        } else {
          countLinkClick({
            variables: { linkId: data?.getTrackerLinkBySlug?.linkId, url: location.href || `${process.env.APP_URL}${location.pathname}` },
          }).finally(() => {
            redirect();
          });
        }

      }
    },
    [
      data?.getTrackerLinkBySlug,
      location,
      redirect,
      loading,
      ploading,
      profileData,
    ],
  );
  const url = new URL(data?.getTrackerLinkBySlug?.destination);
  const localUrl = new URL(process.env.APP_URL);
  return localUrl.host !== url.host
    ? (
      <Page
        title='Redirecting...'
      >
        <Loading>
          <div className={styles.message}>
            Redirecting you to <a href={data?.getTrackerLinkBySlug?.destination}>{data?.getTrackerLinkBySlug?.destination}</a>, one moment...
          </div>
        </Loading>
      </Page>
    )
    : null;
};

export default OldLinkPage;
